export const colors = {
  // Canonical palette
  white: '#FFFFFF',
  black: '#0B1929',
  navy: '#0B1929',
  midnight: '#1A2332',
  steelBlue: '#2E4057',
  brightBlue: '#048ABF',
  electricCyan: '#00D9FF',
  purpleAccent: '#7C3AED',
  lightGrey: '#F7F9FC',
  textPrimary: '#0B1929',
  textSecondary: '#64748B',
  success: '#10B981',
  warning: '#F59E0B',

  // Blues mapped to requested scheme
  blue50: '#E6F7FD',
  blue100: '#CDECF9',
  blue200: '#A0DFF5',
  blue400: '#29B0DA',
  blue600: '#048ABF', // bright blue
  blue700: '#2E4057', // steel blue
  blue800: '#0B1929', // navy

  // Legacy keys used across components (mapped to palette)
  accent: '#0B1929',        // navy
  accentDark: '#1A2332',    // midnight
  background: '#F7F9FC',    // light grey
  backgroundDark: '#E9EEF5',
  backgroundDarker: '#DFE7F1',
  buttonBackground: '#048ABF' // bright blue
};

export const breakpoints = {
  xs: 0,
  // tslint:disable-next-line:object-literal-sort-keys
  sm: 750,
  md: 970,
  lg: 1170
};
